import { z } from "zod";
import { parseStringToNumber } from "../format";

const createCurrencySchemaWithMin = (min: number) => {
  return z
    .number()
    .min(min, `Il valore deve essere maggiore di ${min}€`)
    .or(z.string().min(1, `Il valore deve essere maggiore di ${min}€`));
};

/**
 * Soglia minima accettata da ogni campo monetario del prodotto: tariffe,
 * salary range e budget. Non è specifica della tariffa oraria — usarla come
 * default per `createCurrencyValidatorWithMinSchema` invece di ripetere il 10.
 */
export const MIN_AMOUNT_EUR = 10;

export const createCurrencyValidatorWithMinSchema = (min: number) => {
  const schema = createCurrencySchemaWithMin(min);
  const validationFunction = (value: number | string) => {
    const result = schema.safeParse(value);
    if (!result.success) {
      return {
        isValid: false,
        error: result.error.issues[0].message,
        value: undefined,
      };
    }
    const valueAsNumber = parseStringToNumber(result.data.toString());
    const validatedAsNumber = schema.safeParse(valueAsNumber);
    if (!validatedAsNumber.success) {
      return {
        isValid: false,
        error: validatedAsNumber.error.issues[0].message,
        value: undefined,
      };
    }

    return {
      isValid: true,
      value: valueAsNumber,
      error: undefined,
    };
  };
  return {
    validationFunction,
    schema,
  };
};
